<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closePartnerRequestButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div class="o-media c-content u-no-p u-osb-sm">
					<div class="o-media__img">
						<avatar [user]="vm.service?.user" [default]="'doctor'"></avatar>
					</div>
					<div class="o-media__body">
						<p class="c-text c-text--bold c-text--lg u-osb-xs">{{ vm.service?.user?.firstname }} {{ vm.service?.user?.lastname }}</p>
						<p class="c-text c-text--gray">{{ vm.service?.occupation }}{{ vm.service?.company }}</p>
					</div>
				</div>
				<form *ngIf="!vm.sent" name="vm.form" class="c-form u-ost-xl" novalidate #mainForm="ngForm">
					<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': vm.submitted && contentModel.invalid }">
						<label for="{{ 'content-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">Introduce yourself and share a few times that work for you.</label>
						<textarea id="{{ 'content-' + vm.uid }}" name="content" class="c-form__input c-form__input--sm" [(ngModel)]="vm.data.content" #contentModel="ngModel" maxlength="1000" required rows="6"></textarea>
						<p class="c-text c-text--sm c-text--gray c-text--right" [ngClass]="{'c-text--s3': vm.submitted && contentModel.invalid }">{{ contentModel?.value?.length || 0 }} / 1000</p>
						<item-form-error *ngIf="vm.submitted && contentModel.invalid" [fieldName]="'Partners.Contact.Message_Label' | translate" [error]="contentModel.errors" [noOffset]="true"></item-form-error>
					</div>
					<div class="o-grid o-grid--wrap" style="margin: 0 -5px;">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up" style="padding: 0 5px 10px 5px;">
							<button id="cancelPartnerRequestButton" type="button" class="c-button c-button--s6 c-button--fit" style="width:100%;" (click)="vm.close()">{{ 'Common.Cancel' | translate }}</button>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up" style="padding: 0 5px;">
							<button id="submitPartnerRequestButton" type="button" class="c-button c-button--s1 c-button--fit" style="width:100%;" (click)="vm.handleFormSubmit(mainForm)" [disabled]="vm.processing || (vm.submitted && mainForm.invalid)">{{ 'Partners.Contact.Send_Message' | translate }}</button>
						</div>
					</div>
				</form>
				<div *ngIf="vm.sent" class="u-ost-xl">
					<p class="c-text u-osb-lg">{{ 'Partners.Contact.Success_Message' | translate }}</p>
					<button id="closePartnerRequestSuccessButton" type="button" class="c-button c-button--s1 c-button--fit" style="width:100%;" (click)="vm.close()">{{ 'Common.Close' | translate }}</button>
				</div>
				<loader-overlay *ngIf="vm.processing"></loader-overlay>
			</div>
		</div>
	</div>
</div>
